import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { DIMENSION_INPUT_SIZE } from "../elements/dimensioninput.jsx";
import { PropertiesField } from "../field/index.jsx";
import {
  ICON_HOVER_TYPE,
  ICON_SHAPE,
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

export function NumberProperty({
  label,
  value,
  onChange = () => {},
  units,
  onReset,
  modified,
  size = DIMENSION_INPUT_SIZE.NORMAL,
  inheritedFrom,
  showReset,
  showInherit,
  isDisabled,
  isInline,
  getPanelContainer,
  min,
  max
}) {
  return (
    <PropertiesField
      inheritedFrom={inheritedFrom}
      label={label}
      onReset={onReset}
      modified={modified}
      showReset={showReset}
      showInherit={showInherit}
      isInline={isInline}
      getPanelContainer={getPanelContainer}
    >
      <div className={styles.inputContainer}>
        <input
          value={value}
          onBlur={(e) => {
            const { value } = e?.target;
            if (value === "") {
              onChange(min);
            }
          }}
          onChange={(e) => {
            const val = e.target.value;
            if (val.length > 0 && !isNaN(val[val.length - 1])) {
              if (Number(val) > Number(max) || Number(val) < Number(min)) {
                return;
              }
              onChange(val);
            } else if (val === "") {
              onChange(val);
            }
          }}
          units={units}
          size={size}
          isDisabled={isDisabled}
          min={min}
          max={max}
        />
        <div className={styles.stepper}>
          <KfIcon
            stroke={ICON_STROKE.BOLD}
            icon={KF_ICONS.ARROW_UP_FILLED_1}
            size={ICON_SIZE.SIZE_8}
            color={`--kf-color-gray-700`}
            hoverType={ICON_HOVER_TYPE.SOLID}
            iconShape={ICON_SHAPE.SQUARE}
            onClick={() => {
              if (value < max) {
                onChange(Number(value) + 1);
              }
            }}
          />
          <KfIcon
            stroke={ICON_STROKE.BOLD}
            icon={KF_ICONS.ARROW_DOWN_FILLED_1}
            size={ICON_SIZE.SIZE_8}
            color={`--kf-color-gray-700`}
            hoverType={ICON_HOVER_TYPE.SOLID}
            iconShape={ICON_SHAPE.SQUARE}
            onClick={() => {
              if (value > min) {
                onChange(Number(value) - 1);
              }
            }}
          />
        </div>
      </div>
    </PropertiesField>
  );
}

NumberProperty.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  units: PropTypes.arrayOf(PropTypes.string),
  modified: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(DIMENSION_INPUT_SIZE)),
  inheritedFrom: PropTypes.string,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  isInline: PropTypes.bool,
  isDisabled: PropTypes.bool,
  getPanelContainer: PropTypes.func
};
